import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from "prop-types";
import axios from "axios";
import Api from "../../../assets/js/utils/Api.js";
import Auth from "../../../assets/js/utils/Auth.js";
import BackgroundSlider from "../../components/Slider/BackgroundSlider.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import userHomePageStyle from "../../../assets/jss/user/userHomePageStyle.jsx";
import LoaderComponent from "../../components/Loader.js";
import ImageDetectText from "../../components/User/Textract/ImageDetectText.jsx"
import ImageAnalyzeText from '../../components/User/Textract/ImageAnalyzeText.jsx';
import ImageReceipt from '../../components/User/Textract/ImageReceipt.jsx';
import PdfDetectText from "../../components/User/Textract/PdfDetectText.jsx";
import PdfAnalyzeText from "../../components/User/Textract/PdfAnalyzeText.jsx";
import PdfReceipt from "../../components/User/Textract/PdfReceipt.jsx";

const TextractResult = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        this.history = this.props.history;

        let resultId = null;
        const { match } = this.props.match;
        if(match && match.params.hasOwnProperty("id")){
            resultId = match.params.id;
        }

        this.state = {
            activeTab: 0,
            response: null,
            resultId: resultId,
            loading: true,
        }
    }
    componentDidMount(){
        const { authorized } = this.store.getState();
        if(!authorized && !Auth.hasAccessToken()){
            const location = this.history.location;
            const loginRequired = "/auth/login?return="+encodeURIComponent(location.pathname+location.search);
            this.history.push(loginRequired);
        }

        this.loadResult()
    }
    onTabChange(urlTab){
        if(urlTab === '0'){
            this.setState({activeTab:0})
        }else if(urlTab === '1'){
            this.setState({activeTab:1})
        }else if(urlTab === '2'){
            this.setState({activeTab:2})
        }else if(urlTab === '3'){
            this.setState({activeTab:3})
        }else if(urlTab === '4'){
            this.setState({activeTab:4})
        }
    }
    loadResult(){
        const { resultId } = this.state;

        const source = axios.CancelToken.source();
        
        this.setState({
            loading: true, 
            showError: false, 
            cancelToken: source,
        });

        let requestData = {
            id: resultId
        };
        
        Api.getResult(requestData, source).then(data => {
            this.setState({
                response: data.response,
                loading: false,
            });
        }).catch(err => {
            console.log(err);
        });
    }
    getTypeText(type){
        let value = '';

        switch (type) {
            case "text":
                value = "Text Detection Task";
                break;
            case "form":
                value = "Form Analysis Task";
                break;
            case "table":
                value = "Table Analysis Task";
                break;
            case "receipt":
                value = "Receipt Analysis Task";
                break;
            default:
                value = "";
                break;
        }

        return value;
    }
    render() {
        const { classes } = this.props;
        const { authorized } = this.store.getState();
        const { activeTab, response, loading } = this.state;
        if(!authorized){
            return (
                <div className={classes.main}>
                    <BackgroundSlider store={this.store} />
                    <Helmet>
                        <title>{process.env.REACT_APP_TITLE}</title>
                    </Helmet>
                </div>
            )
        }
        return (
            <div className={classes.main}>
                <div className={classes.container+" "+classes.textractMainContainer}>
                    <div className={classes.content}>
                        <GridItem>
                            <div className={classes.textractResultContainer}>
                                {
                                    response === null && loading ? 
                                        <LoaderComponent color="custom" align="center" />
                                    : response === null ?
                                        <div className={classes.noData}>Textract Result not found.</div>
                                    :
                                        <>
                                            <h3 className={classes.title}>Textract Result</h3>
                                            <GridContainer>
                                                <GridItem xs={12} sm={6} lg={6}>
                                                    <div className='result-file-section'>
                                                        <div className='header-section'>
                                                            <h5>{(response.format === 'pdf' ? 'PDF' : 'Image')} File Preview ({response.file_name})</h5>
                                                        </div>
                                                        <div className='content-section'>
                                                            {
                                                                response.format === 'pdf' ?
                                                                    <iframe src={response.file_url} id="office_frame" title="Pdf Frame" width="100%" height="600px"></iframe>
                                                                :
                                                                    <div className="image-section">
                                                                        <ImageDetectText data={response.raw} file_url={response.file_url} />
                                                                        <img src={response.file_url} alt={response.file_name} className='image' />
                                                                    </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </GridItem>
                                                <GridItem xs={12} sm={6} lg={6}>
                                                    <div className='result-section'>
                                                        <div className='header-section'>
                                                            <h5>Textract Result - {this.getTypeText(response.type)}</h5>
                                                        </div>
                                                        <div className='content-section'>
                                                            <div className={classes.controls}>
                                                                <GridItem className={classes.controlsTabs}>
                                                                    <div className='sd-custom-tabs textract-tabs'>
                                                                        <div className={'sd-custom-tab '+(activeTab === 0 ? 'active': '')} onClick={() => this.onTabChange("0")}>
                                                                            <span>Raw Text</span>
                                                                        </div>
                                                                        <div className={'sd-custom-tab '+(activeTab === 1 ? 'active': '')} onClick={() => this.onTabChange("1")}>
                                                                            <span>Forms</span>
                                                                        </div>
                                                                        <div className={'sd-custom-tab '+(activeTab === 2 ? 'active': '')} onClick={() => this.onTabChange("2")}>
                                                                            <span>Tables</span>
                                                                        </div>
                                                                        <div className={'sd-custom-tab '+(activeTab === 3 ? 'active': '')} onClick={() => this.onTabChange("3")}>
                                                                            <span>Receipt Summary</span>
                                                                        </div>
                                                                        <div className={'sd-custom-tab '+(activeTab === 4 ? 'active': '')} onClick={() => this.onTabChange("4")}>
                                                                            <span>Receipt Items</span>
                                                                        </div>
                                                                    </div>
                                                                </GridItem>
                                                            </div>
                                                            <div className='textract-tab-content'>
                                                                {
                                                                    activeTab === 0 ? 
                                                                        response.format === 'pdf' ?
                                                                            response.type === 'text' ?
                                                                                <PdfDetectText data={response.raw} file_url={response.file_url} type="text" />
                                                                            : response.type === 'form' ?
                                                                                <PdfAnalyzeText data={response.raw} file_url={response.file_url} type='text' />
                                                                            : response.type === 'table' ?
                                                                                <PdfAnalyzeText data={response.raw} file_url={response.file_url} type='text' />
                                                                            : response.type === 'receipt' ?
                                                                                <PdfReceipt data={response.raw} file_url={response.file_url} type='text' />
                                                                            :
                                                                                <></>
                                                                        :
                                                                            response.type === 'text' ?
                                                                                <ImageDetectText data={response.raw} file_url={response.file_url} type="text" />
                                                                            : response.type === 'form' ?
                                                                                <ImageAnalyzeText data={response.raw} file_url={response.file_url} type='text' />
                                                                            : response.type === 'table' ?
                                                                                <ImageAnalyzeText data={response.raw} file_url={response.file_url} type='text' />
                                                                            : response.type === 'receipt' ?
                                                                                <ImageReceipt data={response.raw} file_url={response.file_url} type='text' />
                                                                            :
                                                                                <></>
                                                                    : activeTab === 1 ? 
                                                                        response.format === 'pdf' ?
                                                                            response.type === 'text' ?
                                                                                <PdfDetectText data={response.raw} file_url={response.file_url} type="form" />
                                                                            : response.type === 'form' ?
                                                                                <PdfAnalyzeText data={response.raw} file_url={response.file_url} type='form' />
                                                                            : response.type === 'table' ?
                                                                                <PdfAnalyzeText data={response.raw} file_url={response.file_url} type='form' />
                                                                            : response.type === 'receipt' ?
                                                                                <PdfReceipt data={response.raw} file_url={response.file_url} type='form' />
                                                                            : 
                                                                                <></>
                                                                        :
                                                                            response.type === 'text' ?
                                                                                <ImageDetectText data={response.raw} file_url={response.file_url} type="form" />
                                                                            : response.type === 'form' ?
                                                                                <ImageAnalyzeText data={response.raw} file_url={response.file_url} type='form' />
                                                                            : response.type === 'table' ?
                                                                                <ImageAnalyzeText data={response.raw} file_url={response.file_url} type='form' />
                                                                            : response.type === 'receipt' ?
                                                                                <ImageReceipt data={response.raw} file_url={response.file_url} type='form' />
                                                                            :
                                                                                <></>
                                                                    : activeTab === 2 ? 
                                                                        response.format === 'pdf' ?
                                                                            response.type === 'text' ?
                                                                                <PdfDetectText data={response.raw} file_url={response.file_url} type="table" />
                                                                            : response.type === 'form' ?
                                                                                <PdfAnalyzeText data={response.raw} file_url={response.file_url} type='table' />
                                                                            : response.type === 'table' ?
                                                                                <PdfAnalyzeText data={response.raw} file_url={response.file_url} type='table' />
                                                                            : response.type === 'receipt' ?
                                                                                <PdfReceipt data={response.raw} file_url={response.file_url} type='table' />
                                                                            :  
                                                                                <></>
                                                                        :
                                                                            response.type === 'text' ?
                                                                                <ImageDetectText data={response.raw} file_url={response.file_url} type="table" />
                                                                            : response.type === 'form' ?
                                                                                <ImageAnalyzeText data={response.raw} file_url={response.file_url} type='table' />
                                                                            : response.type === 'table' ?
                                                                                <ImageAnalyzeText data={response.raw} file_url={response.file_url} type='table' />
                                                                            : response.type === 'receipt' ?
                                                                                <ImageReceipt data={response.raw} file_url={response.file_url} type='table' />
                                                                            :
                                                                                <></>
                                                                    : activeTab === 3 ? 
                                                                        response.format === 'pdf' ?
                                                                            response.type === 'text' ?
                                                                                <PdfDetectText data={response.raw} file_url={response.file_url} type="receipt" />
                                                                            : response.type === 'form' ?
                                                                                <PdfAnalyzeText data={response.raw} file_url={response.file_url} type='receipt' />
                                                                            : response.type === 'table' ?
                                                                                <PdfAnalyzeText data={response.raw} file_url={response.file_url} type='receipt' />
                                                                            : response.type === 'receipt' ?
                                                                                <PdfReceipt data={response.raw} file_url={response.file_url} type='receiptSummary' />
                                                                            : 
                                                                                <></>
                                                                        :
                                                                            response.type === 'text' ?
                                                                                <ImageDetectText data={response.raw} file_url={response.file_url} type="receipt" />
                                                                            : response.type === 'form' ?
                                                                                <ImageAnalyzeText data={response.raw} file_url={response.file_url} type='receipt' />
                                                                            : response.type === 'table' ?
                                                                                <ImageAnalyzeText data={response.raw} file_url={response.file_url} type='receipt' />
                                                                            : response.type === 'receipt' ?
                                                                                <ImageReceipt data={response.raw} file_url={response.file_url} type='receiptSummary' />
                                                                            :
                                                                                <></>
                                                                    : activeTab === 4 ? 
                                                                        response.format === 'pdf' ?
                                                                            response.type === 'text' ?
                                                                                <PdfDetectText data={response.raw} file_url={response.file_url} type="receipt" />
                                                                            : response.type === 'form' ?
                                                                                <PdfAnalyzeText data={response.raw} file_url={response.file_url} type='receipt' />
                                                                            : response.type === 'table' ?
                                                                                <PdfAnalyzeText data={response.raw} file_url={response.file_url} type='receipt' />
                                                                            : response.type === 'receipt' ?
                                                                                <PdfReceipt data={response.raw} file_url={response.file_url} type='receiptItems' />
                                                                            : 
                                                                                <></>
                                                                        :
                                                                            response.type === 'text' ?
                                                                                <ImageDetectText data={response.raw} file_url={response.file_url} type="receipt" />
                                                                            : response.type === 'form' ?
                                                                                <ImageAnalyzeText data={response.raw} file_url={response.file_url} type='receipt' />
                                                                            : response.type === 'table' ?
                                                                                <ImageAnalyzeText data={response.raw} file_url={response.file_url} type='receipt' />
                                                                            : response.type === 'receipt' ?
                                                                                <ImageReceipt data={response.raw} file_url={response.file_url} type='receiptItems' />
                                                                            :
                                                                                <></>
                                                                    :
                                                                        <></>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </GridItem>
                                            </GridContainer>
                                        </>
                                }
                            </div>
                        </GridItem>
                    </div>
                </div>
                <Helmet>
                    <title>{process.env.REACT_APP_TITLE}</title>
                </Helmet>
            </div>
        )
    }
}

TextractResult.propTypes = {
    classes: PropTypes.object
};

export default withStyles(userHomePageStyle)(TextractResult);
